import { AttributesParent, transformAttributesKeyValue } from './transform'
import { useCustomClient } from './use-custom-client'

import {
    CiWithRelsResultUi,
    ConfigurationItemUi,
    NeighbourSetUi,
    RoleParticipantUI,
    ConfigurationItemSetUi,
    HistoryVersionsListUiConfigurationItemUi,
    ConfigurationItemNeighbourSetUi,
} from '@isdd/metais-common/api/generated/cmdb-swagger'

const baseURL = import.meta.env.VITE_REST_CLIENT_CMDB_TARGET_URL

export const useClientForReadConfigurationItemUsingGET = <T extends ConfigurationItemUi>() =>
    useCustomClient<T>(baseURL, (body) => transformAttributesKeyValue(body as AttributesParent))

export const useClientForGetRoleParticipantUsingGET = <T extends RoleParticipantUI>() =>
    useCustomClient<T>(baseURL, (body) => transformAttributesKeyValue(body.configurationItemUi as AttributesParent))

export const useClientForReadCiNeighboursWithAllRelsUsingGET = <T extends CiWithRelsResultUi>() =>
    useCustomClient<T>(baseURL, (body) => {
        body?.ciWithRels?.forEach?.((rel) => {
            transformAttributesKeyValue(rel.ci as AttributesParent)
        })
    })

export const useClientForReadCiDerivedRelTypesUsingGET = <T extends CiWithRelsResultUi>() =>
    useCustomClient<T>(baseURL, (body) => {
        body?.ciWithRels?.forEach?.((rel) => {
            transformAttributesKeyValue(rel.ci as AttributesParent)
        })
    })

export const useClientForGetRoleParticipantBulkUsingPOST = <T extends RoleParticipantUI[]>() =>
    useCustomClient<T>(baseURL, (body) => {
        body?.forEach?.((rel) => {
            transformAttributesKeyValue(rel.configurationItemUi as AttributesParent)
        })
    })

export const useClientForReadCiListUsingPOST = <T extends ConfigurationItemSetUi>() =>
    useCustomClient<T>(baseURL, (body) => {
        if (body.configurationItemSet) {
            body.configurationItemSet.forEach((configurationItem) => {
                transformAttributesKeyValue(configurationItem as AttributesParent)
            })
        }
    })

export const useClientForreadCiNeighboursUsingPOST = <T extends NeighbourSetUi>() =>
    useCustomClient<T>(baseURL, (body) => {
        body.fromNodes?.neighbourPairs?.forEach((nP) => {
            transformAttributesKeyValue(nP.configurationItem as AttributesParent)
            transformAttributesKeyValue(nP.relationship)
        })
        body.toNodes?.neighbourPairs?.forEach((nP) => {
            transformAttributesKeyValue(nP.configurationItem as AttributesParent)
            transformAttributesKeyValue(nP.relationship)
        })
    })

export const useClientForRefRegistersHistory = <T extends HistoryVersionsListUiConfigurationItemUi>() =>
    useCustomClient<T>(baseURL, (body) => {
        body.historyVersions?.forEach((nP) => {
            transformAttributesKeyValue(nP.item as AttributesParent)
        })
    })

export const useClientForReadCiListNeighboursUsingGET = <T extends ConfigurationItemNeighbourSetUi>() =>
    useCustomClient<T>(baseURL, (body) => {
        body?.toCiSet?.forEach((nP) => {
            transformAttributesKeyValue(nP as AttributesParent)
        })
    })
